export const VERSION = "18.0.0";
